import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import Inputer from "Utils/Helpers/Inputer";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import MButton from "Utils/Helpers/MButton";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setRoadmapData } from "../../../../../Redux/slices/mngrSlice";
import MuiRadioGroup from "Utils/Helpers/MuiRadioGroup";
import { put_roadmap } from "http/components/Roadmap";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditRoadmapData({ row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [controls, setControls] = useSetState({
    status: {
      display: false,
      label: "Status",
      type: "radio",
      value: "",
      items: [
        { key: "Undone", value: "2" },
        { key: "Pending", value: "3" },
        { key: "Done", value: "4" },
      ],
    },
    progress: {
      display: false,
      label: "Progress (0 - 100)",
      type: "number",
      multiLine: false,
      placeholder: "Progress",
      value: 0,
      validation: false,
    },
    title_en: {
      display: true,
      label: row.isParent ? "Title (en)" : "Level (en)",
      type: "text",
      multiLine: false,
      placeholder: "Title (en)",
      value: "",
      validation: false,
    },
    description_en: {
      display: true,
      label: "Description (en)",
      type: "text",
      multiLine: true,
      placeholder: "Description (en)",
      value: "",
      validation: false,
    },
    title_fr: {
      display: true,
      label: row.isParent ? "Title (fr)" : "Level (fr)",
      type: "text",
      multiLine: false,
      placeholder: "Title (fr)",
      value: "",
      validation: false,
    },
    description_fr: {
      display: true,
      label: "Description (fr)",
      type: "text",
      multiLine: true,
      placeholder: "Description (fr)",
      value: "",
      validation: false,
    },
    title_it: {
      display: true,
      label: row.isParent ? "Title (it)" : "Level (it)",
      type: "text",
      multiLine: false,
      placeholder: "Title (it)",
      value: "",
      validation: false,
    },
    description_it: {
      display: true,
      label: "Description (it)",
      type: "text",
      multiLine: true,
      placeholder: "Description (it)",
      value: "",
      validation: false,
    },
  });

  const onEnter = () => {
    if (!row.isParent) {
      const status_value = controls.status.items.find(
        (i) => +i.value === +row.status_id
      );
      setControls({
        status: {
          display: true,
          value: status_value,
        },
      });
      setControls({
        progress: {
          display: ["2", "4"].includes(status_value.value) ? false : true,
          value:
            status_value.value === "2"
              ? "0"
              : status_value.value === "4"
              ? "100"
              : row.value,
          validation: true,
        },
      });
    }
    setControls({
      title_en: { value: row.languages.en.title, validation: true },
    });
    setControls({
      title_fr: { value: row.languages.fr.title, validation: true },
    });
    setControls({
      title_it: { value: row.languages.it.title, validation: true },
    });
    setControls({
      description_en: { value: row.languages.en.description, validation: true },
    });
    setControls({
      description_fr: { value: row.languages.fr.description, validation: true },
    });
    setControls({
      description_it: { value: row.languages.it.description, validation: true },
    });
  };

  const setValue = (name, value, validation) => {
    let _value = value;
    if (name === "progress") {
      if (!_value || +_value < 0) _value = 0;
      if (+_value > 100) _value = 100;
    }
    setControls({ [name]: { value: _value, validation } });
  };

  const onChangeRadio = (name, value) => {
    setControls({ [name]: { value: value } });
    if (name === "status") {
      setControls({
        progress: {
          display: ["2", "4"].includes(value.value) ? false : true,
          value: ["2", "3"].includes(value.value) ? "0" : "100",
          validation: true,
        },
      });
    }
  };

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onSubmit = async () => {
    const {
      status,
      progress,
      title_en,
      description_en,
      title_fr,
      description_fr,
      title_it,
      description_it,
    } = controls;
    if (
      title_en.validation &&
      description_en.validation &&
      (row.isParent || progress.validation)
    ) {
      dispatch(HandleLoading(true));
      const ex = row.isParent
        ? null
        : {
            status: +status.value.value,
            value: +progress.value,
          };
      const response = await put_roadmap({
        id: row.id,
        title: JSON.stringify({
          en: title_en.value ? title_en.value : "",
          fr: title_fr.value ? title_fr.value : "",
          it: title_it.value ? title_it.value : "",
        }),
        description: JSON.stringify({
          en: description_en.value ? description_en.value : "",
          fr: description_fr.value ? description_fr.value : "",
          it: description_it.value ? description_it.value : "",
        }),
        ...ex,
      });
      if (CheckApiStatus(response)) {
        dispatch(setRoadmapData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      setShow(false);
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Pencil size={16} />}
        label="Edit"
        onClick={setShowDialog}
        className="btn-manager btn-edit"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"sm"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-edit"
        >
          <DialogTitle>{`Edit (${row.title})`}</DialogTitle>
          <DialogContent>
            {show && (
              <Grid2 container spacing={2}>
                {Object.keys(controls)
                  .filter((key) => controls[key].display)
                  .map((key, index) => {
                    return (
                      <Grid2
                        size={{
                          sm: controls[key].type === "text" ? 6 : 12,
                          xs: 12,
                        }}
                        key={key + index}
                      >
                        {["text", "number"].includes(controls[key].type) && (
                          <Inputer
                            id={key}
                            setValue={setValue.bind(this)}
                            value={controls[key].value}
                            label={controls[key].label}
                            placeholder={controls[key].placeholder}
                            type={controls[key].type}
                            multiLine={controls[key].multiLine}
                          />
                        )}
                        {controls[key].type === "radio" && (
                          <MuiRadioGroup
                            name={key}
                            value={controls[key].value}
                            label={controls[key].label}
                            items={controls[key].items}
                            onChange={onChangeRadio}
                          />
                        )}
                      </Grid2>
                    );
                  })}
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Update"}
              className="flex-grow-1"
              onClick={onSubmit}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
